import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Map/LocationDetailsCard/index.js",
  _templateObject,
  _templateObject2,
  _this = this;
import React from 'react';
import styled from 'styled-components';
import { useTheme, withTheme } from '../../../core/ThemeProvider';
import config from '../../../config';
import { withStyledAttrs } from '../../../helpers/styled';
import Row from '../../Row';
import Column from '../../Column';
import Card from '../../Card';
import Text from '../../Text';
import Spacing from '../../Spacing';
import { googleSearchApiBaseUrl } from '../config';
import DirectionsPinIcon from '../assets/directionsPin.svg';
export var StyledContainer = styled.div.withConfig({
  displayName: "LocationDetailsCard__StyledContainer",
  componentId: "sc-bazmhb-0"
})(["width:calc(100% - 32px);position:absolute;bottom:24px;display:block;z-index:2;margin:0 16px;", ""], config.media.sm(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: calc(100% - 200px);\n    margin: 0px 100px;\n  "]))));
export var StyledPinIconWrapper = styled.div.withConfig({
  displayName: "LocationDetailsCard__StyledPinIconWrapper",
  componentId: "sc-bazmhb-1"
})(["padding-top:2px;padding-right:10px;"]);
var StyledContentText = styled(Text).withConfig({
  displayName: "LocationDetailsCard__StyledContentText",
  componentId: "sc-bazmhb-2"
})(["text-align:left;"]);
export var StyledDirectionsLinkContainer = styled(Spacing).withConfig({
  displayName: "LocationDetailsCard__StyledDirectionsLinkContainer",
  componentId: "sc-bazmhb-3"
})(["display:flex;cursor:pointer;user-select:none;"]);
export var StyledDirectionsLink = withTheme(withStyledAttrs(Text, {
  type: 'smallBody',
  fontWeight: 'bold'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), function (p) {
  return p.coreTheme.cl_sec_d1;
}));
var LocationDetailsCard = function LocationDetailsCard(_ref) {
  var name = _ref.name,
    descriptionLiner = _ref.descriptionLiner,
    subDescriptionLiner = _ref.subDescriptionLiner,
    postalCode = _ref.postalCode,
    directionsLinkText = _ref.directionsLinkText;
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  var onDirectionsLinkClick = function onDirectionsLinkClick() {
    var query = "".concat(name, ",").concat(postalCode, ",Singapore");
    window.open("".concat(googleSearchApiBaseUrl, "?api=1&query=").concat(query), '_blank');
  };
  return /*#__PURE__*/React.createElement(StyledContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Row, {
    center: "xs",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Column, {
    xs: 12,
    sm: 6,
    md: 5,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Card, {
    shadow: "sm",
    radius: "sm",
    padding: "sm",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Card.Content, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(StyledContentText, {
    type: "body",
    "data-testid": "location-name",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 15
    }
  }, name), descriptionLiner && /*#__PURE__*/React.createElement(StyledContentText, {
    type: "smallBody",
    color: theme.cl_ter_l2,
    "data-testid": "location-description-liner",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 17
    }
  }, "".concat(descriptionLiner)), subDescriptionLiner && /*#__PURE__*/React.createElement(StyledContentText, {
    type: "smallBody",
    color: theme.cl_ter_l2,
    "data-testid": "location-sub-description-liner",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 17
    }
  }, "".concat(subDescriptionLiner)), directionsLinkText && /*#__PURE__*/React.createElement(StyledDirectionsLinkContainer, {
    top: 1,
    onClick: onDirectionsLinkClick,
    "data-testid": "location-directions-link",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(StyledPinIconWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 19
    }
  }, /*#__PURE__*/React.createElement(DirectionsPinIcon, {
    color: theme.cl_sec_d1,
    size: 22,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 21
    }
  })), /*#__PURE__*/React.createElement(StyledDirectionsLink, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 19
    }
  }, directionsLinkText)))))));
};
export default LocationDetailsCard;